import {Injectable} from '@angular/core';

@Injectable()
export class NavParamService {
    public  user: any;
    public child: any;
    public obj: any;
}
